import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/time-and-attendance/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: '/time-and-attendance/summary/daily-place' });
  },
});
